<template>
  <v-container class="background-image white">
    <v-row no-gutters justify="center" class="text-h2 mt-16">
      <div class="main-font">Welcome</div></v-row
    >
    <v-row no-gutters justify="center" style="min-height: 170px" class="py-4">
      <v-img
        class="shrink"
        src="/img/illustrations/plant-growing.svg"
        transition="fade-transition"
        width="170"
        contain
        ><template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-icon size="20" color="white">mdi-image</v-icon>
          </v-row>
        </template>
      </v-img>
    </v-row>
    <v-row no-gutters class="text-subtitle-1 mt-4" justify="center"
      >Here we share <b class="px-1">tips</b> and
      <b class="px-1">stories</b> about plants
    </v-row>
    <v-form
      v-model="isFormValid"
      lazy-validation
      ref="form"
      @submit.prevent="submit"
    >
      <v-row no-gutters justify="center" class="mt-10">
        <v-text-field
          v-model.trim="email"
          type="email"
          append-icon="mdi-email-outline"
          label="E-mail"
          style="max-width: 300px"
          color="primary"
          background-color="white"
          outlined
          rounded
          :rules="[formRules.email, formRules.required]"
        ></v-text-field
      ></v-row>
      <v-row no-gutters justify="center">
        <v-text-field
          v-model="password"
          :append-icon="show ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
          :rules="[formRules.required, formRules.min]"
          :type="show ? 'text' : 'password'"
          required
          label="password"
          hint="Min 6 caractères"
          background-color="white"
          style="max-width: 300px"
          counter
          rounded
          outlined
          @click:append="show = !show"
        ></v-text-field
      ></v-row>

      <v-row no-gutters justify="center" class="pb-2">
        <v-btn
          x-large
          class="text-none background-gradient-reverse"
          rounded
          style="max-width: 300px"
          depressed
          color="primary"
          :disabled="pending"
          :loading="pending"
          dark
          type="submit"
        >
          <span>Sign in / Sign up</span>
        </v-btn>
      </v-row>
    </v-form>
    <!-- <v-dialog v-model="dialog" width="500" content-class="rounded-xl">
      <template v-slot:activator="{ on, attrs }">
        <v-row no-gutters class="mt-1 mb-1" justify="center">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="text-none transparent text-decoration-underline"
            rounded
            small
            depressed
            outlined
          >
            fogrotten password
          </v-btn>
        </v-row>
      </template>

      <v-card class="pa-6">
        <v-form
          v-model="isFormForgottenPasswordValid"
          lazy-validation
          ref="formForgottenPassword"
          @submit.prevent="sendPasswordResetEmail"
        >
          <v-row no-gutters justify="center">
            <v-text-field
              v-model.trim="emailForgottenPassword"
              type="email"
              append-icon="mdi-email-outline"
              label="E-mail"
              color="primary"
              background-color="white"
              outlined
              rounded
              :rules="[formRules.email, formRules.required]"
            ></v-text-field
          ></v-row>
          <v-row no-gutters justify="center">
            <v-btn
              class="text-none"
              color="primary"
              type="submit"
              rounded
              depressed
              :disabled="pending"
              :loading="pending"
              large
            >
              Envoyer <v-icon right>mdi-send-outline</v-icon>
            </v-btn>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>

<script>
import FormRules from "@/utils/form-rules";

export default {
  data: () => ({
    authPending: false,
    pending: false,
    isFormValid: true,
    isFormForgottenPasswordValid: true,
    show: false,
    email: "",
    emailForgottenPassword: "",
    password: "",
    formRules: FormRules,
    dialog: false,
  }),
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.pending = true;
        await this.$store.dispatch("auth/signUp", {
          email: this.email,
          password: this.password,
        });
        this.pending = false;
      }
    },
    async sendPasswordResetEmail() {
      if (this.$refs.formForgottenPassword.validate()) {
        this.pending = true;
        await this.$store.dispatch(
          "auth/sendPasswordResetEmail",
          this.emailForgottenPassword
        );
        this.emailForgottenPassword = "";
        this.pending = false;
        this.dialog = false;
      }
    },
    // async signInTest() {
    //   try {
    //     await this.$store.dispatch("auth/signInTest");
    //     this.$router.push("/");
    //   } finally {
    //   }
    // },
    // async signOutFromFacebook() {
    //   this.authPending = true;
    //   try {
    //     await this.$store.dispatch("auth/signOutFromFacebook");
    //   } finally {
    //     this.authPending = false;
    //   }
    // },
    // async signInWithFacebook() {
    //   this.authPending = true;
    //   try {
    //     await this.$store.dispatch("auth/signInWithFacebook");
    //     this.$router.push("/");
    //   } catch (error) {
    //     this.$store.commit("snackbar/setSnackbar", {
    //       color: "error",
    //       timeout: 4000,
    //       text: error.message,
    //     });
    //   } finally {
    //     this.authPending = false;
    //   }
    // },
  },
};
</script>